export type PollingState = {
  isPolling: boolean;
  pollCount: number;
  timeoutId?: ReturnType<typeof setTimeout> | undefined;
};

export const INITIAL_DELAY = 30000;
export const POLLING_INTERVAL = 10000;
export const MAX_POLLING_DURATION = 180000;

type RawArtworkResponse = {
  id: number | string;
  currentEnhancementState?: string;
  ordered?: {
    imageUrl?: string;
    noBgUrl?: string;
    noBgNoTrimUrl?: string;
    withBgUrl?: string;
    manualEditUrl?: string;
    manualEditNoTrimUrl?: string;
    canRemoveBg?: boolean;
    removeBackground?: boolean;
    enhanceImage?: boolean;
    enhancementTier?: string;
    editImageManual?: boolean;
    metadata?: { error?: string };
    enhancedMetadata?: unknown;
    originalMetadata?: unknown;
    withBgMetadata?: unknown;
  };
  original?: {
    imageUrl?: string;
  };
};

export type NormalizedArtwork = {
  id: string;
  url: string;
  imageUrl: string;
  originalImageUrl: string;
  withBgUrl: string;
  noBgUrl: string;
  noBgNoTrimUrl: string;
  manualEditUrl: string | null;
  manualEditNoTrimUrl: string | null;
  canRemoveBg: boolean;
  removeBackground: boolean;
  enhanceImage: boolean;
  enhancementTier: string;
  editImageManual: boolean;
  currentEnhancementState: string | undefined;
  metadata: { error?: string } | undefined;
  enhancedMetadata: unknown;
  originalMetadata: unknown;
  withBgMetadata: unknown;
};

export function normalizeArtworkResponse(artwork: RawArtworkResponse): NormalizedArtwork {
  const { ordered, original } = artwork;

  const imageUrl = ordered?.imageUrl || "";
  const noBgUrl = ordered?.noBgUrl || "";
  const originalImageUrl = original?.imageUrl || imageUrl;

  return {
    id: String(artwork.id),
    url: noBgUrl || imageUrl,
    imageUrl,
    originalImageUrl,
    withBgUrl: ordered?.withBgUrl || original?.imageUrl || imageUrl,
    noBgUrl,
    noBgNoTrimUrl: ordered?.noBgNoTrimUrl || imageUrl,
    manualEditUrl: ordered?.manualEditUrl || null,
    manualEditNoTrimUrl: ordered?.manualEditNoTrimUrl || null,
    canRemoveBg: ordered?.canRemoveBg ?? true,
    removeBackground: ordered?.removeBackground ?? false,
    enhanceImage: ordered?.enhanceImage ?? true,
    enhancementTier: ordered?.enhancementTier || "full_enhancements",
    editImageManual: ordered?.editImageManual ?? false,
    currentEnhancementState: artwork.currentEnhancementState,
    metadata: ordered?.metadata,
    enhancedMetadata: ordered?.enhancedMetadata,
    originalMetadata: ordered?.originalMetadata,
    withBgMetadata: ordered?.withBgMetadata
  };
}
